import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Identify Symptom',
  desc: 'Fever? Pain? Bloating? → Check the Symptom Matrix'
}, {
  num: '2',
  title: 'Pick Remedy',
  desc: 'Ginger? Turmeric? Fennel? → Choose from 3 prep methods'
}, {
  num: '3',
  title: 'Dose + Apply',
  desc: 'Use the Calculator for your family → Relief in 15–60 min'
}];
export function HowItWorks() {
  return <section className="py-20 bg-white" data-id="element-98">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a3c2a] mb-4" data-id="element-101">
            How It Works
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-102">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-[#e5e7eb] -z-10" data-id="element-103" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col items-center text-center bg-white" data-id="element-104">
              <div className="w-24 h-24 rounded-full bg-[#faf8f0] border-4 border-[#1a3c2a] flex items-center justify-center text-3xl font-bold text-[#1a3c2a] mb-6 shadow-lg" data-id="element-105">
                {step.num}
              </div>
              <h3 className="text-xl font-bold text-[#1a3c2a] mb-3" data-id="element-106">
                {step.title}
              </h3>
              <p className="text-[#5c4a32] px-4" data-id="element-107">{step.desc}</p>
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-108">
          <p className="text-lg font-medium text-[#c9a84c] italic" data-id="element-109">
            Repeat for 200+ symptoms.
          </p>
        </div>
      </div>
    </section>;
}